var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState, useEffect, useRef, useCallback } from 'react';
import { useQuery } from 'react-query';
import { ticketsService } from 'src/Utils/ticketsService';
var useTicketAlertsModal = function () {
    var _a = useState({
        isOpen: false,
        alerts: [],
    }), modalState = _a[0], setModalState = _a[1];
    var openModal = useCallback(function (alerts, options) {
        if (alerts.length > 0) {
            setModalState(__assign({ isOpen: true, alerts: alerts }, options));
        }
    }, []);
    var closeModal = useCallback(function () {
        setModalState(function (prev) { return (__assign(__assign({}, prev), { isOpen: false })); });
    }, []);
    return { modalState: modalState, openModal: openModal, closeModal: closeModal };
};
export var useTicketAlerts = function (_a) {
    var buildingId = _a.buildingId, apartmentId = _a.apartmentId, buildings = _a.buildings, apartments = _a.apartments;
    var _b = useTicketAlertsModal(), modalState = _b.modalState, openModal = _b.openModal, closeModal = _b.closeModal;
    var previousBuildingId = useRef(null);
    var previousApartmentId = useRef(null);
    var buildingAlertsChecked = useRef(false);
    var apartmentAlertsChecked = useRef(false);
    var closeModalTimeoutRef = useRef(null);
    var refetchBuildingAlerts = useQuery(['building-alerts', buildingId], function () {
        if (!buildingId)
            return Promise.resolve({ ticket_alerts: [] });
        return ticketsService.getBuildingGenericAlerts(buildingId);
    }, {
        enabled: false,
        onSuccess: function (data) {
            var alerts = (data === null || data === void 0 ? void 0 : data.ticket_alerts) || [];
            if (alerts.length > 0) {
                var building = buildings.find(function (b) { return b.id === buildingId; });
                openModal(alerts, {
                    buildingName: (building === null || building === void 0 ? void 0 : building.name) || (building === null || building === void 0 ? void 0 : building.code) || '',
                });
            }
            buildingAlertsChecked.current = true;
        },
    }).refetch;
    var refetchApartmentAlerts = useQuery(['apartment-alerts', buildingId, apartmentId], function () {
        if (!buildingId || !apartmentId)
            return Promise.resolve({ ticket_alerts: [] });
        return ticketsService.getApartmentAlerts(buildingId, apartmentId);
    }, {
        enabled: false,
        onSuccess: function (data) {
            var alerts = (data === null || data === void 0 ? void 0 : data.ticket_alerts) || [];
            if (alerts.length > 0) {
                var apartment = apartments.find(function (a) { return a.id === apartmentId; });
                openModal(alerts, {
                    apartmentNumber: (apartment === null || apartment === void 0 ? void 0 : apartment.number) || '',
                });
            }
            apartmentAlertsChecked.current = true;
        },
    }).refetch;
    useEffect(function () {
        if (!buildingId || buildings.length === 0)
            return;
        if (previousBuildingId.current === buildingId && previousBuildingId.current !== null) {
            return;
        }
        previousBuildingId.current = buildingId;
        buildingAlertsChecked.current = false;
        previousApartmentId.current = null;
        apartmentAlertsChecked.current = false;
        var timeoutId = setTimeout(function () {
            if (buildingId && !buildingAlertsChecked.current) {
                refetchBuildingAlerts();
            }
        }, 100);
        return function () { return clearTimeout(timeoutId); };
    }, [buildingId, buildings.length, refetchBuildingAlerts]);
    useEffect(function () {
        if (buildingId &&
            apartmentId &&
            apartmentId !== previousApartmentId.current &&
            (buildingAlertsChecked.current || !buildingId)) {
            previousApartmentId.current = apartmentId;
            apartmentAlertsChecked.current = false;
            var timeoutId_1 = setTimeout(function () {
                if (buildingId && apartmentId && !apartmentAlertsChecked.current) {
                    refetchApartmentAlerts();
                }
            }, 100);
            return function () { return clearTimeout(timeoutId_1); };
        }
    }, [buildingId, apartmentId, refetchApartmentAlerts]);
    var closeAlertModal = useCallback(function () {
        var wasBuildingModal = !modalState.apartmentNumber;
        closeModal();
        if (wasBuildingModal && buildingId && apartmentId && !apartmentAlertsChecked.current) {
            if (closeModalTimeoutRef.current) {
                clearTimeout(closeModalTimeoutRef.current);
            }
            closeModalTimeoutRef.current = setTimeout(function () {
                if (buildingId && apartmentId && !apartmentAlertsChecked.current) {
                    refetchApartmentAlerts();
                }
                closeModalTimeoutRef.current = null;
            }, 100);
        }
    }, [modalState.apartmentNumber, closeModal, buildingId, apartmentId, refetchApartmentAlerts]);
    useEffect(function () {
        return function () {
            if (closeModalTimeoutRef.current) {
                clearTimeout(closeModalTimeoutRef.current);
            }
        };
    }, []);
    return {
        alertModal: modalState,
        closeAlertModal: closeAlertModal,
    };
};
